module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upload-area",
    class: {
      'dragover': _vm.isDragging,
      'uploading': _vm.uploading
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.isDragging = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.isDragging = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.handleFileDrop.apply(null, arguments)
      },
      "click": _vm.triggerFileInput
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFileSelect
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "cloud upload icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "upload-text"
  }, [_vm._v("Click to upload or drag and drop")]), _vm._v(" "), _c('p', {
    staticClass: "upload-hint"
  }, [_vm._v("CSV file up to 10MB")])]), _vm._v(" "), (_vm.uploadedFile) ? _c('div', {
    staticClass: "uploaded-file"
  }, [_c('i', {
    staticClass: "file icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.uploadedFile.name))]), _vm._v(" "), _c('button', {
    staticClass: "remove-file",
    on: {
      "click": _vm.removeFile
    }
  }, [_c('i', {
    staticClass: "times icon"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dcd452e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/FileUploadArea.vue
// module id = 781
// module chunks = 2